import {
  formatLocalDateInput,
  startOfLocalDay,
} from "./subscriptionPeriodDate";

/** Календарный год: 01.01.Y — min(31.12.Y, сегодня) для текущего года. */
export function getCalendarYearRange(year) {
  const today = startOfLocalDay();
  const y =
    year !== undefined && year !== null && Number.isFinite(Number(year))
      ? Number(year)
      : today.getFullYear();
  const from = new Date(y, 0, 1);
  let to;
  if (y < today.getFullYear()) {
    to = new Date(y, 11, 31);
  } else if (y > today.getFullYear()) {
    to = new Date(y, 0, 1);
  } else {
    to = today;
  }
  return {
    from: formatLocalDateInput(from),
    to: formatLocalDateInput(to),
    year: y,
  };
}
